module.exports = __webpack_public_path__ + "static/media/menu.95208c6b.svg";